import React from 'react';
import background from '../../assets/arabica.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';

class InfoAgriculture extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="LAND"
        description="Agriculture"
        paragraph="Global food calorie production is projected to increase 70 percent between 2006 and 2050 (Resource Watch). "
        background={background}
     />
  
  );
 }
}   

export default InfoAgriculture;